import React, { useRef, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './dialog';

export default function ConfirmDialog({ title, description, action = 'Remove', onConfirm, onClose, returnFocusRef }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const cancelRef = useRef(null);
  const busyRef = useRef(false);
  async function confirm() {
    if (busyRef.current) return;
    busyRef.current = true; setBusy(true); setError('');
    try { await onConfirm(); onClose(); }
    catch (cause) { setError(cause?.message || 'The action could not be completed. Try again.'); }
    finally { busyRef.current = false; setBusy(false); }
  }
  return <Dialog open onOpenChange={open => { if (!open && !busyRef.current) onClose(); }}>
    <DialogContent role="alertdialog" hideClose returnFocusRef={returnFocusRef} onOpenAutoFocus={event => { event.preventDefault(); cancelRef.current?.focus(); }}>
      <DialogHeader><DialogTitle>{title}</DialogTitle><DialogDescription>{description}</DialogDescription></DialogHeader>
      {error && <p role="alert" className="accessible-error text-destructive">{error}</p>}
      {busy && <p role="status">Please wait…</p>}
      <DialogFooter>
        <button ref={cancelRef} type="button" disabled={busy} onClick={onClose} className="min-h-11 rounded-lg border border-border px-4">Cancel</button>
        <button type="button" disabled={busy} onClick={confirm} className="min-h-11 rounded-lg bg-primary px-4 font-semibold text-primary-foreground">{action}</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>;
}
